import React from 'react';

import WidgetDashboard from '../widget-dashboard/WidgetDashboard';

/**
 * Landing page (`/`): the customizable widget dashboard (muokattava työpöytä). The fixed
 * legacy landing page it replaced lives on as the Klassinen preset.
 */
export default function MainDesktopView() {
  return <WidgetDashboard />;
}
